import gql from 'graphql-tag';

export const CREATE_ACTIVITY_BOOKING = gql`
  mutation createActivityBooking(
    $accommodationBooking: AccommodationBookingInput
    $activityBooking: ActivityBookingInput!
  ) {
    createActivityBooking(
      accommodationBooking: $accommodationBooking
      activityBooking: $activityBooking
    ) {
      id
      clientSecret
      nextActionUrl
    }
  }
`;

export const UPDATE_ACTIVITY_BOOKING = gql`
  mutation updateActivityBooking(
    $activityBooking: ActivityBookingInput!
    $accommodationBooking: AccommodationBookingInput
    $deletedAccommodationBooking: [Int]
  ) {
    updateActivityBooking(
      activityBooking: $activityBooking
      accommodationBooking: $accommodationBooking
      deletedAccommodationBooking: $deletedAccommodationBooking
    ) {
      id
    }
  }
`;
